
import React from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface SortingSelectProps {
  sortBy: string;
  setSortBy: (value: string) => void;
}

export function SortingSelect({ sortBy, setSortBy }: SortingSelectProps) {
  // Map sort value to display text
  const getSortDisplayText = (value: string) => {
    switch (value) {
      case "name_asc": return "Name (A-Z)";
      case "name_desc": return "Name (Z-A)";
      case "established_asc": return "Oldest First";
      case "established_desc": return "Newest First";
      case "capacity_asc": return "Capacity (Low-High)";
      case "capacity_desc": return "Capacity (High-Low)";
      default: return "Name (A-Z)";
    }
  };

  return (
    <Select 
      value={sortBy} 
      onValueChange={setSortBy}
    >
      <SelectTrigger className="w-full sm:w-[180px] bg-white h-10 text-sm border-grandpal-beige">
        <SelectValue placeholder={getSortDisplayText(sortBy)} />
      </SelectTrigger>
      <SelectContent className="bg-white border-grandpal-beige">
        <SelectGroup>
          <SelectItem value="name_asc" className="text-sm">Name (A-Z)</SelectItem>
          <SelectItem value="name_desc" className="text-sm">Name (Z-A)</SelectItem>
          <SelectItem value="established_asc" className="text-sm">Oldest First</SelectItem>
          <SelectItem value="established_desc" className="text-sm">Newest First</SelectItem>
          <SelectItem value="capacity_asc" className="text-sm">Capacity (Low-High)</SelectItem>
          <SelectItem value="capacity_desc" className="text-sm">Capacity (High-Low)</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
